module.exports = __webpack_public_path__ + "img/historia_3-4.06b394f5.webp";